/* eslint-disable no-inline-comments */
// import { Button } from '@kaboodle-solutions/design-system';
import CreditHeaderIcon from './CreditHeaderIcon';
import PropTypes from 'prop-types';
import React from 'react';
import { formatPrice } from '../../lib/formatting';
import styles from './CreditHeader.styles';
import { withStyles } from '@kaboodle-solutions/design-system';

const CreditHeader = ({ classes, credit }) => {
  const getCreditTotal = () => {
    if (credit.length > 1) {
      const creditTotal = credit.reduce(
        (acc, cur) => acc.credit_value + cur.credit_value,
      );

      return formatPrice('£', creditTotal / 100, 2);
    }

    return credit[0].credit_display;
  };

  return (
    <div className={classes.creditBox}>
      <div className={classes.creditHeaderIcon}>
        <CreditHeaderIcon className={classes.creditIcon} />
      </div>
      <div className={classes.creditHeader}>
        <span className={classes.label}>Credit Total</span>
        <span className={classes.total} data-testid="credit-total">
          {getCreditTotal()}
        </span>
      </div>
      {/* <div className={classes.creditHeaderButton}>
        <Button
          className={classes.button}
          testId="goToCreditScreen"
          size="medium"
          type="button"
          variant="secondary">
          View available credit
        </Button>
      </div> */}
    </div>
  );
};

CreditHeader.propTypes = {
  classes: PropTypes.shape({
    button: PropTypes.string,
    creditBox: PropTypes.string,
    creditHeader: PropTypes.string,
    creditHeaderButton: PropTypes.string,
    creditHeaderIcon: PropTypes.string,
    creditIcon: PropTypes.string,
    label: PropTypes.string,
    total: PropTypes.string,
  }).isRequired,
  credit: PropTypes.arrayOf(
    PropTypes.shape({
      credit_display: PropTypes.string.isRequired,
      credit_value: PropTypes.number.isRequired,
      currency_exponent: PropTypes.number.isRequired,
      currency_iso_code: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default withStyles(styles)(CreditHeader);
